<template>
<div class="product-item" @click="gotoProductDetail">
  <div class="product-bg" :style="{'background': `url(${product.website_bkg_img}) no-repeat center / 100% 100%`}"></div>
  <div class="product-info">
    <div class="product-name">{{product.product_name}}</div>
    <div class="product-price" v-if="User.isLogin()">
      <div class="sell-price">¥{{$showPrice(product.special_price || product.peer_price)}}</div>
      <div class="original-price" v-if="product.special_price">¥{{$showPrice(product.peer_price)}}</div>
    </div>
    <div class="product-price" v-else>
      <div class="sell-price">¥ -</div>
    </div>
  </div>
</div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import User from '../../../../libs/user';

export default {
  name: '',
  components: {},
  props: {
    product: Object,
  },
  data() {
    return {
      User,
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    gotoProductDetail() {
      sensorsdata.track('ActivityGoodsClick', {
        activity_name: '2023-618',
      });
      this.$router.push({ name: 'productDetail', query: { visa_product_id: this.product.product_id, from: '618-2023' } });
    },
  },
};
</script>

<style scoped lang="less">
.product-item{
  width: 314px;
  height: 293px;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
  .product-bg{
    width: 100%;
    height: 157px;
  }
  .product-info{
    padding: 16px;
    .product-name{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      color: #333333;
      font-size: 20px;
      line-height: 32px;
      min-height: 64px;
    }
    .product-price{
      margin-top: 16px;
      display: flex;
      align-items: center;
      .sell-price{
        color: #FF0082;
        font-size: 24px;
        font-weight: 600;
      }
      .original-price{
        color: #666666;
        font-size: 20px;
        margin-left: 15px;
        text-decoration: line-through;
      }
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/pages/activity/festival/components/product-item.vue